import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { Icon, Label } from '@atlas/ui';

const BARCODE_WIDTH = 244;
const BARCODE_HEIGHT = 105;

export const BarcodeField = ({ value }) => {
  const svgRef = useRef(null);
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    if (!value) return;

    setStatus('loading');

    import('jsbarcode')
      .then(({ default: JsBarcode }) => {
        if (!svgRef.current) return;

        const fontFamily =
          getComputedStyle(document.documentElement).getPropertyValue('--fontFamily').trim() ||
          'Helvetica, sans-serif';

        JsBarcode(svgRef.current, value, {
          displayValue: true,
          font: fontFamily,
          format: 'CODE128',
          fontSize: 16,
          fontWeight: '500',
          height: 60,
          margin: 10,
          width: 2,
        });

        const svg = svgRef.current;
        const naturalW = parseInt(svg.getAttribute('width'), 10);
        const naturalH = parseInt(svg.getAttribute('height'), 10);

        if (naturalW && naturalH) {
          svg.setAttribute('viewBox', `0 0 ${naturalW} ${naturalH}`);
          svg.setAttribute('preserveAspectRatio', 'none');
          svg.setAttribute('width', BARCODE_WIDTH);
          svg.setAttribute('height', BARCODE_HEIGHT);
        }

        setStatus('ready');
      })
      .catch(() => setStatus('error'));
  }, [value]);

  if (status === 'error') {
    return (
      <div className="barcode-field">
        <div className="barcode-field__error">
          <Icon className="barcode-field__error-icon" name="error" />
          <Label className="barcode-field__error-title" message="barcode_failed_to_load" />
          <Label className="barcode-field__error-subtitle" message="barcode_please_try_again" />
        </div>
      </div>
    );
  }

  return (
    <div className="barcode-field">
      <div className={cx('barcode-field__card', { 'barcode-field__card--loading': status === 'loading' })}>
        <svg ref={svgRef} style={status === 'loading' ? { display: 'none' } : {}} />
      </div>
      {status === 'ready' && <span className="barcode-field__value">{value}</span>}
    </div>
  );
};

BarcodeField.propTypes = {
  value: PropTypes.string.isRequired,
};
